
import { FREQUENCY_SLIDER_VALUES, campaignFrequencies, campaignSliderFrequencies } from '@/statics/campaign-wizard';
import { CampaignFrequency, FREQUENCY, FrequencyUserType } from '@/types/campaigns';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import namespaces from '@/store/namespaces';
import { LocationData } from '@/types/locations';
import { AuthorizedUser } from '@/types/users';
import { getFrequencySliderEnabledForStoreOwner } from '@/actions/adspaces/actions';
import { fetchCampaignDefaultFrequencyConfigByUserRole } from '@/actions/campaigns/actions';
import { USER_ROLES } from '@/statics/user-roles';
import { TimeSlotSelection } from '@/types/time-slots';

@Component({
  components: {},
})
export default class TimeSelection extends Vue {
  @Prop({ type: Object }) frequency!: CampaignFrequency;

  @Getter('selectedLocations', { namespace: namespaces.CampaignWizardModule })
  public selectedLocations!: LocationData[];

  @Getter('userInfo', { namespace: namespaces.AuthModule })
  public userInfo!: AuthorizedUser;

  @Getter('time', { namespace: namespaces.CampaignWizardModule })
  public campaignWizardSelectedTimeSlots!: TimeSlotSelection;

  public defaultFrequency!:FREQUENCY;
  public frequencies = campaignFrequencies;
  public timeFrequenciesInMinutes: number[] = [];
  public isFrequencySliderEnabled = false;

  public get sliderValue() {
    return FREQUENCY_SLIDER_VALUES[this.frequency?.NAME];
  }

  public set sliderValue(sliderValue: number) {
    const selectedFrequency = campaignSliderFrequencies[sliderValue];
    this.$emit('update:frequency', selectedFrequency);
  }

  public get frequencyInMinutes() {
    return this.frequency?.MINUTES;
  }

  public get tickLabels() {
    return Object.values(this.frequencies).map(({ LABEL }) => this.$t(LABEL));
  }

  public async mounted() {
    try {
      const {
        enforcedFrequency,
        defaultFrequency
      } = await fetchCampaignDefaultFrequencyConfigByUserRole(USER_ROLES.STORE_OWNER.VAL as FrequencyUserType)
      this.defaultFrequency = defaultFrequency;
      this.timeFrequenciesInMinutes = Object.values(this.frequencies).map(({ MINUTES }) => MINUTES);
      this.isFrequencySliderEnabled = await getFrequencySliderEnabledForStoreOwner(this.userInfo!.UID)
      if (!this.campaignWizardSelectedTimeSlots?.frequency) {
        const frequencyKey = this.isFrequencySliderEnabled
            ? defaultFrequency
            : enforcedFrequency;

        this.sliderValue = FREQUENCY_SLIDER_VALUES[frequencyKey];
      }
      if (this.isFrequencySliderEnabled) {
        this.syncDefaultChoiceLabelOnFrequencySlider();
      }
    }catch (e) {
      console.log('error', e)
    }
  }

  @Watch('frequency')
  highlightSelectedFrequency() {
    const selectedFrequency = document.querySelector('.selected-frequency-minutes');
    if (selectedFrequency) {
      selectedFrequency.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  syncDefaultChoiceLabelOnFrequencySlider() {
    this.$nextTick(() => {
      // Get the default choice label from vue-i18n
      const ticks = this.$el.querySelectorAll('.v-slider__tick-label');
      const defaultTick = ticks[FREQUENCY_SLIDER_VALUES[this.defaultFrequency]];
      const div = document.createElement('div');
      div.classList.add('default-choice');
      div.id='default-choice'
      div.textContent = this.$t('default_choice').toString(); // Dynamic suffix
      defaultTick?.appendChild(div);
    });
  }

  @Watch('$vuetify.rtl')
  localeChanged() {
    if(this.isFrequencySliderEnabled){
      const div = this.$el.querySelector('#default-choice');
      if (div) {
        div.textContent = this.$t('default_choice').toString();
      }
    }


  }
}
